// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_2HMGwdt3ycc7_mMZeWigRb","activeDropzone":"_33zj0PPJBY3Ix7Yart359Q","rejectDropzone":"ul-vrjYboBBhznF6yhpeR","button":"_5xzutcohQ0eFghfTTazjC","fileList":"_2wubbKV2BqY3R-lnadf9bG","fileListHeader":"_1SZ_4xp42xnAWVeHjXjCBM"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UploadPapers/UploadPapers.css
// module id = 754
// module chunks = 3